import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { SparkLinePointDtoSchema } from '../contracts';

const _GetStaffingRatioRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

const GetStaffingRatioResponseDtoSchema = z.object({
  ratio: z.string(),
  ratioValue: z.number().nullable(),
  // Staff from Sling: HPRD instead of the Staffing Ratio.
  metric: z.enum(['RATIO', 'HPRD']).optional(),
  hprdValue: z.number().nullable().optional(),
  level: z
    .enum(['UNDERSTAFFED', 'NORMAL', 'OVERSTAFFED'])
    .nullable()
    .optional(),
  message: z.string().nullable().optional(),
  changePct: z.number().nullable(),
  sparkline: z.object({
    granularity: z.enum(['day', 'week', 'month']),
    points: z.array(SparkLinePointDtoSchema),
  }),
});

export type GetStaffingRatioRequestDto = z.infer<
  typeof _GetStaffingRatioRequestDtoSchema
>;
export type GetStaffingRatioResponseDto = z.infer<
  typeof GetStaffingRatioResponseDtoSchema
>;

export const getStaffingRatio = (
  params: GetStaffingRatioRequestDto,
  config?: AxiosRequestConfig<GetStaffingRatioRequestDto>
) => {
  return api
    .get('/staff/staffing-ratio', {
      params,
      ...config,
    })
    .then(responseContract(GetStaffingRatioResponseDtoSchema));
};
